<app-header-frame-module [isAdmin]="true"></app-header-frame-module>

<div class="container mb-3">
    <h2>{{ 'Validation de trames' | uppercase }}</h2>
    <hr>
    <div class="row" *ngIf="frames.length > 0">
        <!-- Colonne gauche : Tableau -->
        <div class="col-lg-8 pr-3">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Recherche rapide par fournisseur, statut, date de soumission...</mat-label>
                <input matInput type="text" (keyup)="searchFrames($event)">
            </mat-form-field>
            <table>
                <thead>
                    <tr>
                        <th (click)="sortBy('submissionDate')">
                            Date de soumission
                            <mat-icon
                                [ngStyle]="{visibility: currentSort.column === 'submissionDate' ? 'visible' : 'hidden'}">
                                {{ currentSort.direction === 'asc' ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                        </th>
                        <th (click)="sortBy('publicationDate')">
                            Date de publication
                            <mat-icon
                                [ngStyle]="{visibility: currentSort.column === 'publicationDate' ? 'visible' : 'hidden'}">
                                {{ currentSort.direction === 'asc' ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                        </th>
                        <th (click)="sortBy('supplier.value')">
                            Fournisseur
                            <mat-icon
                            [ngStyle]="{visibility: currentSort.column === 'supplier.value' ? 'visible' : 'hidden'}">
                            {{ currentSort.direction === 'asc' ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                        </th>
                        <th (click)="sortBy('frameType.labels.fr_FR')">
                            Type de trame
                            <mat-icon
                            [ngStyle]="{visibility: currentSort.column === 'frameType.labels.fr_FR' ? 'visible' : 'hidden'}">
                            {{ currentSort.direction === 'asc' ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                        </th>
                        <th (click)="sortBy('status.labels.fr_FR')">
                            Statut
                            <mat-icon
                            [ngStyle]="{visibility: currentSort.column === 'status.labels.fr_FR' ? 'visible' : 'hidden'}">
                            {{ currentSort.direction === 'asc' ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let frame of sortedFrames" (click)="selectFrame(frame)"
                        [ngClass]="{'selected-row': frame === selectedFrame}">
                        <td>{{ frame.submissionDate | date:'short' }}</td>
                        <td>{{ frame.publicationDate | date:'dd/MM/yyyy' }}</td>
                        <td>{{ frame.supplier.value || '-' }}</td>
                        <td>{{ frame.frameType?.value || '-' }}</td>
                        <td>{{ frame.status.labels?.fr_FR || '-' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Détails de la trame -->
        <div class="col-lg-4" *ngIf="selectedFrame">
            <h3>
                {{ selectedFrame.supplier.value || 'Fournisseur inconnu' }} -
                Trame {{ selectedFrame.frameType?.value == 'Produits' ? 'Produit':'Tarif' }} du
                {{ selectedFrame.submissionDate | date:'dd/MM/yyyy' }}
            </h3>
            <p><strong>Statut :</strong> {{ selectedFrame.status.labels?.fr_FR }}</p>
            <p><strong>Trame Excel :</strong> {{ selectedFrame.frameName }}</p>
            <!-- <p><strong>Photos :</strong> -</p>
            <p><strong>Documents :</strong> -</p> -->
            <p><strong>Date de soumission :</strong> {{ selectedFrame.submissionDate | date:'short' }}</p>
            <p><strong>Date de publication :</strong> {{ selectedFrame.publicationDate | date:'dd/MM/yyyy' }}</p>
            <!-- <p><strong>Fournisseur :</strong> {{ selectedFrame.supplier?.value }}</p> -->
            <hr>
            <ul style="list-style: none;" class="p-0">
                <li>Nombre de lignes traitées : {{ importStats.totalLines }}</li>
                <!-- <li>Nombre de lignes ignorées : {{ importStats.ignoredLines }}</li> -->
                <li class="text-success">Nombre de lignes valides : {{ importStats.validLines }}</li>
                <li class="text-warning">Nombre de lignes avec alerte : {{ importStats.alertLines }}</li>
                <li class="text-warning">Nombre d'articles dépubliés : {{ importStats.nbDepublie }}</li>
                <li class="text-danger">Nombre de lignes en erreur : {{ importStats.errorLines }}</li>
               
            </ul>
            
            

            <div class="form-group">
              <div id="report-bloc"></div>
            </div>

            <button mat-raised-button class="btn my-3" (click)="downloadReport()">{{'Télécharger le rapport'| uppercase}}</button>


            <div class="mb-3 d-flex justify-content-between" *ngIf="needValidation">
                <button mat-raised-button class="btn-danger" (click)="refuse()">{{'Refuser'| uppercase}}</button>
                <button mat-raised-button class="btn-primary" (click)="submit()">{{'Valider'| uppercase}}</button>
            </div>
        </div>
    </div>
</div>